import axios from 'axios';

const axiosProvisioningCognito = axios.create()
axiosProvisioningCognito.interceptors.request.use((config) => {
  config.headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "x-api-key": process.env.REACT_APP_PROVISIONING_COGNITO_TOKEN,
    "Tenant-host": "marquet"
  }
  return config;
}, (error) => {
  return Promise.reject(error);
})
axiosProvisioningCognito.interceptors.response.use((response) => {
  return response;
}, (error) => {
  return Promise.reject(error);
});

export default axiosProvisioningCognito;